
import axios from 'axios';
import api from './api';

/**
 * 获取一些全局常量 Map
 * @returns {AxiosPromise}
 */
function getGlobalMap()
{
  return axios.post(api.basePath + '/getGlobalMap');
}

/**
 * 根据数据字典名称获取数据字典集合
 * @param dictName 字典名称
 * @returns {AxiosPromise<any>}
 */
function getDictByType(dictName)
{
  return axios.post(api.basePath + "/dictByName/" + dictName)
}

/**
 * 常用枚举值集合类
 * @param _value
 * @returns {AxiosPromise}
 */
function getCommEnum(_value)
{
  return axios.post(api.basePath + '/enumMap/CommEnum$' + _value);
}

/**
 * 状态
 * @returns {AxiosPromise}
 */
function getStatusDict()
{
  return getCommEnum("Status");
}

/**
 * 是与否
 * @returns {AxiosPromise}
 */
function getYesOrNoDict()
{
  return getCommEnum("YesOrNo");
}

/**
 * 日志枚举值集合类
 * @param _value
 * @returns {AxiosPromise}
 */

/**
 * 操作类型
 * @returns {AxiosPromise}
 */
function getOperTypeDict()
{
  return getDictByType("log_oper_type");
}

/**
 * 操作模式
 * @returns {AxiosPromise}
 */
function getOperModeDict()
{
  return getDictByType("log_oper_mode");
}

/**
 * 用户枚举值集合类
 * @param _value
 * @returns {AxiosPromise}
 */
function getUserEnum(_value)
{
  return axios.post(api.basePath + '/enumMap/UserEnum$' + _value);
}
/**
 * 用户状态
 * @returns {AxiosPromise}
 */
function getUserStateDict()
{
  return getUserEnum("UserState");
}

/**
 * 认证状态
 * @returns {AxiosPromise}
 */
function getAuditStateDict()
{
  return getUserEnum("AuditState");
}

/**
 * 用户类型
 * @returns {AxiosPromise}
 */
function getUserTypeDict()
{
  return getUserEnum("UserType");
}

/**
 * 添加方式
 * @returns {AxiosPromise}
 */
function getAddWayDict()
{
  return getUserEnum("AddWay");
}

/**
 * 证件类型
 * @returns {AxiosPromise}
 */
function getIdTypeDict()
{
  return getUserEnum("IdType");
}

/**
 * 验证状态
 * @returns {AxiosPromise}
 */
function getCardVerifyDict()
{
  return getUserEnum("CardVerify");
}

/**
 * 认证类型
 * @returns {AxiosPromise}
 */
function getApproveTypeDict()
{
  return getUserEnum("ApproveType");
}

/**
 * 用户数据权限
 * @returns {AxiosPromise}
 */
function getDataScopeDict()
{
  return getUserEnum("DataScope");
}

/**
 * 机构枚举值集合类
 * @param _value
 * @returns {AxiosPromise}
 */
function getOrgEnum(_value)
{
  return axios.post(api.basePath + '/enumMap/OrgEnum$' + _value);
}

/**
 * 机构类型
 * @returns {AxiosPromise}
 */
function getOrgTypeDict()
{
  return getOrgEnum("Type");
}

/**
 * 机构证件类型
 * @returns {AxiosPromise}
 */
function getCertificateTypeDict()
{
  return getOrgEnum("CertificateType");
}

/**
 * 机构状态
 * @returns {AxiosPromise}
 */
function getOrgStatusDict()
{
  return getOrgEnum("Status");
}

/**
 * 机构认证状态
 * @returns {AxiosPromise}
 */
function getAuthStatusDict()
{
  return getOrgEnum("AuthStatus");
}

/**
 * 机构认证类型
 * @returns {AxiosPromise}
 */
function getAuthTypeDict()
{
  return getOrgEnum("AuthType");
}

/**
 * 角色枚举值集合类
 * @param _value
 * @returns {AxiosPromise}
 */
function getRoleEnum(_value)
{
  return axios.post(api.basePath + '/enumMap/RoleEnum$' + _value);
}

function getRoleTypeDict()
{
  return getRoleEnum("RoleType");
}

/**
 * 获取合同相关枚举字典集合
 * @param className
 * @returns {AxiosPromise<any>}
 */
function getEnumListByClassName(className)
{
  return axios.post(api.basePath + '/enumMap/' + className);
}

//项目管理
// 项目分类状态

function getPprojectTypeState(){
  return getEnumListByClassName("EnableStatusEnum");
}
/**
 * 获取合同类型属性枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractTypeFileNatureEnum()
{
  return getEnumListByClassName("ContractTypeNatureEnum");
}

function getFlowNodeSignTypeEnum()
{
  return getEnumListByClassName("FlowNodeSignTypeEnum");
}

//获取合同类型
function getContractTypeEnum()
{
  return getDictByType("yryj_contract_type");
}

// 获取项目承接名义
function getProjectUtknom(){
  return getDictByType("project_utknom");
}
/**
 * 获取合同类型状态枚举集合
 * @returns {AxiosPromise<any>}
 */


function getContractTypeStatusEnum()
{
  return getEnumListByClassName("ContractTypeStatusEnum");
}

//获取合同操作类型
function getContractLogOpFlagEnum(){
  return getEnumListByClassName("ContractLogOpFlagEnum");
}
/**
 * 获取合同模板状态枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractTemplateStateEnum()
{
  return getEnumListByClassName("ContractTemplateStateEnum");
}

/**
 * 获取合同模板创建方式枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractTemplateEffectEnum()
{
  return getEnumListByClassName("ContractTemplateEffectEnum");
}

/**
 * 获取合同模板创建方式枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractTemplateCreatewayEnum()
{
  return getEnumListByClassName("ContractTemplateCreatewayEnum");
}

/**
 * 获取合同模板生效方式枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractTemplateEffectEnum()
{
  return getEnumListByClassName("ContractTemplateEffectEnum");
}

/**
 * 获取合同模板变量数据类型枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractVariableDataEnum()
{
  return getEnumListByClassName("ContractVariableDataEnum");
}

/**
 * 获取合同模板变量输入框类型枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractVariableInputEnum()
{
  return getEnumListByClassName("ContractVariableInputEnum");
}

/**
 * 获取合同模板变量输入框类型枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractVariableInputEnum()
{
  return getEnumListByClassName("ContractVariableInputEnum");
}

/**
 * 获取合同模板变量来源枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractVariableSourceEnum()
{
  return getEnumListByClassName("ContractVariableSourceEnum");
}

/**
 * 获取合同模板变量属性枚举集合
 * @returns {AxiosPromise<any>}
 */
function getContractVariableVarAttrEnum()
{
  return getEnumListByClassName("ContractVariableVarAttrEnum");
}

/**
 * 获取文件类型枚举集合
 * @returns {AxiosPromise<any>}
 */
function getFileTypeEnum()
{
  return getEnumListByClassName("FileTypeEnum");
}

/**
 * 获取签约人类型枚举集合（合同类型定义的签约人类型）
 * @returns {AxiosPromise<any>}
 */
function getSignTypeEnum()
{
  return getEnumListByClassName("SignTypeEnum");
}

/**
 * 获取签约人类型枚举集合（合同实际签约人类型）
 * @returns {AxiosPromise<any>}
 */
function getSignUserTypeEnum()
{
  return getEnumListByClassName("SignUserTypeEnum");
}

/**
 * 合同签约状态
 * */
function getSignStateEnum()
{
  return getEnumListByClassName("SignStateEnum");
}
function getSignSealTypeCodeEnum () {
  return getEnumListByClassName('SignSealTypeCodeEnum')
}
function getSealTypeEnum () {
  return getEnumListByClassName('SealTypeEnum')
}
/**
 * 获取合同状态枚举
 * @returns {AxiosPromise<any>}
 */
function getContractStateEnum()
{
  return getEnumListByClassName("ContractStateEnum");
}

/**
 * 获取待办合同状态枚举
 * @returns {AxiosPromise<any>}
 */
function getContractWaitingEnum()
{
  return getEnumListByClassName("ContractWaitingEnum");
}

/**
 * 获取合同审核状态枚举
 * @returns {AxiosPromise<any>}
 */
function getAuditStatusEnum()
{
  return getEnumListByClassName("AuditStatusEnum");
}

/**
 * 获取合同审核结果枚举
 * @returns {AxiosPromise<any>}
 */
function getAuditResultEnum()
{
  return getEnumListByClassName("AuditResultEnum");
}

function getUserEnumRelType()
{
  return getEnumListByClassName("UserEnum$RelType");
}

/**
 * 常用枚举值集合类
 * @param _value
 * @returns {AxiosPromise}
 */
function getContractEnum(_value)
{
  return axios.post(api.basePath + '/enumMap/ContractEnum$' + _value);
}

/**
 * 批量代办合同枚举
 * **/
function getCommEnumbatch()
{
  return getContractEnum('ContractWaiting');
}

/**
 * 签署合同设置 证书类型枚举
 * CertificateTypeEnum
 **/
function getCertificateTypeEnum()
{
  return getEnumListByClassName("CertificateTypeEnum");
}

/*
* 签署合同设置 签署方式枚举
* SignChannelEnum
* */
function getSignChannelEnum()
{
  return getEnumListByClassName("SignChannelEnum");
}

export default {
  getGlobalMap,
  getDictByType,

  // 公共常用枚举值字典
  getStatusDict,
  getYesOrNoDict,

  // 日志方面枚举值字典
  getOperModeDict,
  getOperTypeDict,

  // 用户方面枚举值字典
  getUserStateDict,
  getAuditStateDict,
  getUserTypeDict,
  getAddWayDict,
  getIdTypeDict,
  getCardVerifyDict,
  getApproveTypeDict,
  getDataScopeDict,

  // 机构方面枚举值字典
  getOrgTypeDict,
  getCertificateTypeDict,
  getOrgStatusDict,
  getAuthStatusDict,
  getAuthTypeDict,
  getUserEnumRelType,
  // 角色方面枚举值字典
  getRoleTypeDict,

  // 合同类型相关枚举字典
  getContractTypeFileNatureEnum,
  getContractTypeStatusEnum,
  getContractTypeEnum,
  getContractLogOpFlagEnum,
  getFlowNodeSignTypeEnum,

  // 合同模板相关枚举字典
  getContractTemplateStateEnum,
  getContractTemplateCreatewayEnum,
  getContractTemplateEffectEnum,
  getContractVariableDataEnum,
  getContractVariableInputEnum,
  getContractVariableSourceEnum,
  getContractVariableVarAttrEnum,
  getFileTypeEnum,
  getSignTypeEnum,
  getSignUserTypeEnum,

  // 合同相关枚举字典
  getContractStateEnum,
  getAuditStatusEnum,
  getAuditResultEnum,
  //合同签约状态
  getSignStateEnum,
  getSignSealTypeCodeEnum,
  getSealTypeEnum,
  getContractWaitingEnum,
  //批量代办合同状态
  getCommEnumbatch,
  getCertificateTypeEnum,
  getSignChannelEnum,
  //项目
  getPprojectTypeState,
  getProjectUtknom,
}



// WEBPACK FOOTER //
// ./src/assets/js/dict.js